// export constants used throughout the program to avoid working with strings.
export const getChannelsColumnTypes = "getChannelsColumnTypes";
export const getChannelsMeasures = "getChannelsMeasures";
export const getChannelsChannels = "getChannelsChannels";
export const executeExportChannelsQuery = "executeExportChannelsQuery";
export const executeChannelsQuery = "executeChannelsQuery";
export const executeChannelsQueryMoreExclude =
  "executeChannelsQueryMoreExclude";
export const getChannelsTimeshift = "getChannelsTimeshift";
export const changeSortChannels = "changeSortChannels";
export const executeChannelsRoFQuery = "executeChannelsRoFQuery";
export const executeScheduleQuery = "executeScheduleChannelsQuery";
